export default "__VITE_ASSET__Q_TQ02P___"